// extracted by mini-css-extract-plugin
export default {"container":"withStyledTags_container__kTq3V","container-lg":"withStyledTags_container-lg__TQwMl","with_styled_tags":"withStyledTags_with_styled_tags__udwUe"};